import Vue from 'vue';
import { MutationTree } from "vuex";
import { SubscriptionDescriptionState } from "@/types/store/clientzone";
import { SubscriptionDescriptionsData } from "@/types";

export const mutations: MutationTree<SubscriptionDescriptionState> = {
  SET_SUBSCRIPTION_DESCRIPTIONS: (state, payload: Array<SubscriptionDescriptionsData>): Array<SubscriptionDescriptionsData> => Vue.set(state, 'subscriptionDescriptions', payload)
}
